import Vue from 'vue/dist/vue.esm';
import axios from 'common/axios';
import MyListIndex from 'components/my_lists/my_list_index.vue';
import VueTextareaAutosize from 'vue-textarea-autosize';

document.addEventListener('page:change', () => {
  const friendId = JSON.parse(document.getElementById('my_lists').dataset.friendId);
  const isMypage = JSON.parse(document.getElementById('my_lists').dataset.isMypage);
  const showMyListId = JSON.parse(document.getElementById('my_lists').dataset.myListId);

  Vue.use(VueTextareaAutosize);

  new Vue({
    el: '#my_lists',
    components: { MyListIndex },
    data: {
      myList: {},
      myLists: [],
      myListElements: [],
      myListRelatedHistories: [],
      myListPage: 1,
      myListElementPage: 1,
      myListRelatedHistoryPage: 1,
      myListDestroyCount: 0,
      myListElementDestroyCount: 0,
      infiniteIdForIndex: +new Date(),
      infiniteIdForShow: +new Date(),
      infiniteIdForHistory: +new Date(),
      visibleMyListForm: false,
      visibleEditMyListElementForm: false,
      firstLoaded: false,
      metaTags: {}
    },
    computed: {
      friendId: function () {
        return friendId;
      },
      isMypage: function () {
        return isMypage;
      },
      showMyListId: function () {
        return showMyListId;
      },
      indexMyListPath: function () {
        return `/friends/${this.friendId}/my_lists`;
      },
      createMyListPath: function () {
        return '/mypage/my_lists';
      },
      myListRelatedHistoriesPath: function () {
        return `/friends/${this.friendId}/my_list_related_histories`;
      }
    },
    watch: {
      'metaTags.title': function() {
        document.querySelector('title').setAttribute('content', this.metaTags.title);
        document.querySelector('meta[name="description"]').setAttribute('content', this.metaTags.description);
        document.querySelector('meta[property="og:title"]').setAttribute('content', this.metaTags.title);
        document.querySelector('meta[property="og:description"]').setAttribute('content', this.metaTags.description);
        document.querySelector('meta[property="og:url"]').setAttribute('content', location.href);
        document.querySelector('#title .twitter').href = `https://twitter.com/share?url=${location.href}&text=${this.metaTags.title}`;
        document.querySelector('#title .facebook').href = `https://www.facebook.com/sharer.php?u=${location.href}`;
        document.querySelector('#title .line').href = `https://line.me/R/msg/text/?${this.metaTags.title}${location.href}`;
      }
    },
    created: function() {
      axios.get(this.indexMyListPath, {
        params: {
          page: 1,
          destroy_count: 0
        }
      }).then(({ data }) => {
        if (data.my_lists.length) {
          this.myLists = data.my_lists;
          this.myListPage += 1;
        }
        this.firstLoaded = true;
      });
    },
    methods: {
      showMylistPath: function (myListId) {
        return `${this.indexMyListPath}/${myListId}`;
      },
      updateMyListPath: function (myListId) {
        return `/mypage/my_lists/${myListId}`;
      },
      destroyMyListPath: function (myListId) {
        return `/mypage/my_lists/${myListId}`;
      },
      updateMyListElementPath: function (myListId, myListElementId) {
        return `/mypage/my_lists/${myListId}/elements/${myListElementId}`;
      },
      destroyMyListElementPath: function (myListId, myListElementId) {
        return `/mypage/my_lists/${myListId}/elements/${myListElementId}`;
      },
      updateOrderMyListElementsPath: function (myListId) {
        return `/mypage/my_lists/${myListId}/elements/update_order`;
      },
      indexMyList: function($state) {
        axios.get(this.indexMyListPath, {
          params: {
            page: this.myListPage,
            destroy_count: this.myListDestroyCount
          }
        }).then(({ data }) => {
          if (data.my_lists.length) {
            this.myListPage == 1 ? this.myLists = data.my_lists : this.myLists.push(...data.my_lists);
            this.myListPage += 1;
            $state.loaded();
            if (data.last_page) {
              $state.complete();
            }
          } else {
            $state.complete();
          }
        });
      },
      showMyList: function ($state, myListId) {
        axios.get(this.showMylistPath(myListId), {
          params: {
            page: this.myListElementPage,
            destroy_count: this.myListElementDestroyCount
          }
        }).then(({ data }) => {
          this.myList = data.my_list;
          this.metaTags = data.meta_tags;
          if (data.my_list_elements.length) {
            this.myListElementPage == 1 ? this.myListElements = data.my_list_elements : this.myListElements.push(...data.my_list_elements);
            this.myListElementPage += 1;
            $state.loaded();
            if (data.last_page) {
              $state.complete();
            }
          } else {
            $state.complete();
          }
        });
      },
      indexMyListRelatedHistory: function($state) {
        axios.get(this.myListRelatedHistoriesPath, {
          params: {
            page: this.myListRelatedHistoryPage
          }
        }).then(({ data }) => {
          if (data.my_list_related_histories.length) {
            this.myListRelatedHistoryPage == 1 ? this.myListRelatedHistories = data.my_list_related_histories : this.myListRelatedHistories.push(...data.my_list_related_histories);
            this.myListRelatedHistoryPage += 1;
            $state.loaded();
            if (data.last_page) {
              $state.complete();
            }
          } else {
            $state.complete();
          }
        });
      },
      createMyList: async function (myListForForm) {
        let res = await axios.post(this.createMyListPath, myListForForm);
        this.onCreateMyList(res.data.my_list_id);
      },
      updateMyList: async function (myListForForm) {
        await axios.patch(this.updateMyListPath(myListForForm.id), myListForForm);
        this.onUpdateMyList(myListForForm);
      },
      destroyMyList: function (myListId) {
        axios.delete(this.destroyMyListPath(myListId));
        this.onDestroyMyList(myListId);
      },
      updateMyListElement: async function (editMyListElement, myListId) {
        await axios.patch(this.updateMyListElementPath(myListId, editMyListElement.id), editMyListElement);
        this.onUpdateMyListElement(editMyListElement);
      },
      destroyMyListElement: async function (myListId, myListElementId) {
        await axios.delete(this.destroyMyListElementPath(myListId, myListElementId));
        this.onDestroyMyListElement(myListElementId, myListId);
      },
      updateOrderMyListElements: async function (myListId) {
        await axios.patch(this.updateOrderMyListElementsPath(myListId), {
          my_list_element_ids: this.myListElements.map((myListElement) => myListElement.id)
        });
      },
      setMyListElements: function(myListElements) {
        this.myListElements = myListElements;
      },
      resetShowPage: function () {
        this.myList = {};
        this.myListElements = [];
        this.myListElementPage = 1;
        this.myListElementDestroyCount = 0;
        this.infiniteIdForShow++;
      },
      resetHistoryPage: function () {
        this.myListRelatedHistories = [];
        this.myListRelatedHistoryPage = 1;
        this.infiniteIdForHistory++;
      },
      showMyListForm: function() {
        this.visibleMyListForm = true;
      },
      hideMyListForm: function() {
        this.visibleMyListForm = false;
      },
      showEditMyListElementForm: function() {
        this.visibleEditMyListElementForm = true;
      },
      hideEditMyListElementForm: function() {
        this.visibleEditMyListElementForm = false;
      },
      onCreateMyList: function(myListId) {
        this.hideMyListForm();
        this.myLists = [];
        this.myListPage = 1;
        this.myListDestroyCount = 0;
        this.infiniteIdForIndex++;
        this.indexMyList(this.$refs.myListIndex.$refs.infiniteLoadingForIndex.stateChanger);
        this.$refs.myListIndex.setMyListId(myListId);
      },
      onUpdateMyList: function(myListForForm) {
        this.hideMyListForm();
        let targetIndex = this.myLists.findIndex((myList) => myList.id == myListForForm.id);
        this.$set(this.myLists, targetIndex, {...myListForForm});
        this.myList = {...myListForForm};
      },
      onDestroyMyList: function(myListId) {
        this.hideMyListForm();
        this.myLists = this.myLists.filter((myList) => myList.id != myListId);
        this.myListDestroyCount++;
        this.$refs.myListIndex.viewHistoryPage();
      },
      onDestroyMyListElement: function(myListElementId, myListId) {
        this.setMyListElements(this.myListElements.filter((myListElement) => myListElement.id != myListElementId));
        this.changeMyListSize(myListId, -1);
        this.myListElementDestroyCount++;
      },
      onUpdateMyListElement: function(editMyListElement) {
        this.hideEditMyListElementForm();
        let targetIndex = this.myListElements.findIndex((myListElement) => myListElement.id == editMyListElement.id);
        this.$set(this.myListElements, targetIndex, {...editMyListElement});
      },
      changeMyListSize(myListId, sizeOfChange) {
        let targetIndex = this.myLists.findIndex((myList) => myList.id == myListId);
        this.$set(this.myLists[targetIndex], 'size', this.myLists[targetIndex].size + sizeOfChange);
      }
    },
    template: `
      <div>
        <my-list-index
          ref='myListIndex'
          :showMyList='myList'
          :myLists='myLists'
          :myListElements='myListElements'
          :myListRelatedHistories='myListRelatedHistories'
          :infiniteIdForIndex='infiniteIdForIndex'
          :infiniteIdForShow='infiniteIdForShow'
          :infiniteIdForHistory='infiniteIdForHistory'
          :indexMyListPath='indexMyListPath'
          :showMyListIdFromParent='showMyListId'
          :isMypage='isMypage'
          :visibleMyListForm='visibleMyListForm'
          :visibleEditMyListElementForm='visibleEditMyListElementForm'
          :firstLoaded='firstLoaded'
          :friendId='friendId'
          @index-my-list='indexMyList'
          @show-my-list='showMyList'
          @index-my-list-related-history='indexMyListRelatedHistory'
          @create-my-list='createMyList'
          @update-my-list='updateMyList'
          @destroy-my-list='destroyMyList'
          @update-my-list-element='updateMyListElement'
          @destroy-my-list-element='destroyMyListElement'
          @update-order-my-list-elements='updateOrderMyListElements'
          @set-my-list-elements='setMyListElements'
          @reset-show-page='resetShowPage'
          @reset-history-page='resetHistoryPage'
          @show-my-list-form='showMyListForm'
          @hide-my-list-form='hideMyListForm'
          @show-edit-my-list-element-form='showEditMyListElementForm'
          @hide-edit-my-list-element-form='hideEditMyListElementForm'
          @change-my-list-size='changeMyListSize'
        >
        </my-list-index>
      </div>
    `
  });
});
